// Constants
import AC from "components/Stacker/constants/ApplicationConstants"

import { getDY_SR } from "stackerConfig"

export const initialState = {
  isSPA: false,
  isSystemError: false,
  systemErrorMessage: "",
  redirectUrl: "",
  isEPS: getDY_SR().config.global.baseStore === "eps",
  isPriceDisclaimerEnabled: getDY_SR().config.global.isPriceDisclaimerEnabled,
  baseStore: getDY_SR().config.global.baseStore,
  pid: null,
  baseURL: getDY_SR().config.global.baseURL,
  csrfToken: "",
  holidayGiftGuidePath: getDY_SR().config.global.holidayGiftGuidePath,
  isInternationalShippingEnabled:
    getDY_SR().config.global.isInternationalShippingEnabled,
  isAffirmEnabledOnSite: getDY_SR().config.global.isAffirmEnabled,
  locationHistory: {},
}

export default function applicationReducer(
  previousState = initialState,
  action
) {
  switch (action.type) {
    case AC.SPA_ENABLED:
      return {
        ...previousState,
        isSPA: true,
      }
    case AC.SYSTEM_ERROR_OCCURED:
      return {
        ...previousState,
        isSystemError: true,
        systemErrorMessage: action.payload,
      }

    case AC.SYSTEM_ERROR_CLEARED:
      return {
        ...previousState,
        isSystemError: false,
        systemErrorMessage: "",
      }

    case AC.SET_REDIRECT_URL:
      return {
        ...previousState,
        redirectUrl: action.payload.url,
        pid: action.payload.pid,
      }

    case AC.CLEAR_REDIRECT_URL:
      return {
        ...previousState,
        redirectUrl: "",
        pid: "",
      }

    case AC.CSRF_TOKEN_SET:
      return {
        ...previousState,
        csrfToken: action.payload,
      }
    case AC.SET_PREVIOUS_HISTORY:
      return {
        ...previousState,
        locationHistory: {
          ...previousState.locationHistory,
          ...action.payload,
        },
      }

    default:
      return previousState
  }
}
